import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from "@angular/common/http";
import { catchError, Observable,throwError } from "rxjs";
import { Router } from "@angular/router";
import { environment } from "../environments/environment";
import { OAuthService } from "angular-oauth2-oidc";
 
 
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router,
    private oauthService: OAuthService,
 
  ) {}
 
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const origin = window.location.origin;
    // console.log("ori?gin" ,origin)
    // const origin = request.headers.get('origin') || 'Origin not available';
    // console.log('Request Origin:', origin);
    // alert(origin)
    // alert("interceptor run")
 
    const token = localStorage.getItem("access_token");
    // console.log("token from intercept", token)
    // alert("token alert")
    // console.log(token)
    const targetDomain1 = "https://localhost:8001";
    const targetDomain2 = "https://gbresapp01.azurewebsites.net";
    const targetDomain3 =
      "https://grsceqdev-h4a6g3gbgsh7hpe2.eastus-01.azurewebsites.net";
      const targetDomain4 = "https://grs.mcd.com"
    const targetDomain5 = "https://gbresprodapp01.azurewebsites.net"
    const istargetDomain =
      origin.includes(targetDomain1) ||
      origin.includes(targetDomain2) ||
      origin.includes(targetDomain3)||
      origin.includes(targetDomain4) ||
      origin.includes(targetDomain5);

      
    // console.log(istargetDomain);
 
    if (token && istargetDomain) {
      const clone = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next.handle(clone).pipe(
        catchError((error:HttpErrorResponse)=>{
          if(error.status == 401){
            localStorage.clear();
            sessionStorage.clear();
             setTimeout(() => {
      this.oauthService.logOut();
    }, 100);
 
            // window.location.href = environment.useProdConfiguration ? "https://login.microsoftonline.com/dbd61555-f8c0-4db8-83e3-d55f7565507d/oauth2/v2.0/authorize":'https://login.microsoftonline.com/dbd61555-f8c0-4db8-83e3-d55f7565507d/oauth2/logout'
          }
           return throwError(() => error);
        })
      );
    }
    return next.handle(request);
   
  }
 
}
 